
import './App.css';

import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import { Dashboard } from './pages/Dashboard';
import { api_authenticate } from './api/Api';

function App() {
	/*
	 * Current Logged in user.
	 */
	const [user, setUser] = React.useState();

	/*
	 * Status message for login/signup forms and status bar.
	 *
	 * message: String Message to display on login/signup form or status bar.
	 * fieldErrors: [String]: Field errors to highlight on login/signup/edit forms.
	 * error: boolean for status bar error highlighting.
	 * 
	 */
	const [formStatus, setFormStatus] = React.useState("");

	function login(userDetails) {
		api_authenticate(userDetails, setFormStatus, setUser)
	}

	function logout() {
		//console.log("Logout")
		setUser(undefined)
	}

	function isLoggedIn() {
		return user !== undefined
	}

	function getUser() {
		return user;
	}

	return (
		<div className="App">
			<Router>
				<Routes>
					
					{/* Routes for logged in user */}
					{!isLoggedIn() && <Route path="/*" element={<Dashboard card="Login" className="landing" login={login} formStatus={formStatus} />} />}
					
					{/* Routes for logged in user */}
					{isLoggedIn() && <Route path="/" element={<Dashboard card="Dashboard" className="dashboard" username={getUser()} logout={logout} formStatus={formStatus} setFormStatus={setFormStatus} />} />}
					{isLoggedIn() && <Route path="/notepad" element={<Dashboard card="Notepad" className="dashboard" username={getUser()} logout={logout} formStatus={formStatus} setFormStatus={setFormStatus} /> } />}
					{isLoggedIn() && <Route path="/Contacts_Dave" element={<Dashboard card="Contacts_Dave" className="dashboard" username={getUser()} logout={logout} formStatus={formStatus} setFormStatus={setFormStatus} /> } />}
					{isLoggedIn() && <Route path="/Contacts_Katsia" element={<Dashboard card="Contacts_Katsia" className="dashboard" username={getUser()} logout={logout} formStatus={formStatus} setFormStatus={setFormStatus} /> } />}
					{isLoggedIn() && <Route path="/Users_Katsia" element={<Dashboard card="Users_Katsia" className="dashboard" username={getUser()} logout={logout} formStatus={formStatus} setFormStatus={setFormStatus} /> } />}

				</Routes>
			</Router>
		</div>
	);
}

export default App;